import { render, staticRenderFns } from "./ToolbarLogo.vue?vue&type=template&id=fce8683e"
import script from "./ToolbarLogo.vue?vue&type=script&lang=js"
export * from "./ToolbarLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports